import React from "react";
import { connect } from "react-redux";
import { updateContent } from "../actions/cartAction";
import { Modal, Figure, Row, Col, Button, Spinner } from "react-bootstrap";
import { addImage, getImages } from "../firebase/images";

export const ImageManagerContext = React.createContext({
  callback: null,
  request(callback) {},
  clear() {},
});

class ImageManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      uploading: false,
    };
    this.onInputChange = this.onInputChange.bind(this);
    this.onAddImage = this.onAddImage.bind(this);
  }

  onSelect(context, image) {
    return (event) => {
      event.preventDefault();
      // console.log('select', image)
      context.callback(image);
      context.clear();
    };
  }
  onInputChange(e) {
    if (e.target.files[0]) {
      this.setState({
        image: e.target.files[0],
      });
    }
  }
  onAddImage(context) {
    const { image } = this.state;
    let name;
    this.setState({ loading: true });
    return addImage(image)
      .then((image) => {
        name = image.name;
        return getImages();
      })
      .then((images) => {
        return this.props.updateContent(images);
      })
      .then(() => {
        context.callback(name);
      })
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    return (
      <ImageManagerContext.Consumer>
        {(context) => {
          return (
            <Modal
              dialogClassName="image-modal"
              show={!!context.callback}
              onHide={() => {
                context.clear();
              }}
            >
              <Modal.Body>
                <Row>
                  {this.props.images.map((image) => (
                    <Col key={image.name}>
                      <Figure className="image">
                        <Figure.Image alt={image.name} src={image.url} />
                        <Figure.Caption className="caption">
                          <a
                            href={image.url}
                            onClick={this.onSelect(context, image.name)}
                          >
                            {image.name}
                          </a>
                        </Figure.Caption>
                      </Figure>
                    </Col>
                  ))}
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <div>
                  <input type="file" onChange={this.onInputChange} />
                  <Button
                    variant="secondary"
                    onClick={() => this.onAddImage(context)}
                  >
                    {this.state.loading
                      ? [
                          <Spinner as="span" animation="border" size="sm" />,
                          "Uploading...",
                        ]
                      : "Upload Image"}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          );
        }}
      </ImageManagerContext.Consumer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    images: state.images,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateContent(images) {
      dispatch(updateContent(null, images));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageManager);
